module.exports = __webpack_public_path__ + "img/full4-min.3cc0c265.png";